import { PaintSwatch } from '../../../model/Swatches'

const generateSwatchesStyles = (paintSwatches: PaintSwatch[]) => {
  if (!paintSwatches) {
    return {}
  }

  const result = {}

  paintSwatches.forEach((swatch) => {
    result[
      swatch.paintId.trim().toUpperCase()
    ] = `linear-gradient(135deg,${swatch.colourHexHigh},${swatch.colourHexLow})`
  })

  return result
}

export { generateSwatchesStyles }
